import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';
import { GraphqlError } from 'src/errors';
import useUI from 'hooks/use-ui';
import { useCheckAgeVerificationQuery } from 'types/graphql';

type UseCheckAgeVerificationProps = {
  dispensaryId: string | undefined;
  userId: string | undefined;
};

type UseCheckAgeVerificationReturn = {
  isAgeVerified: boolean | undefined;
  loading: boolean;
};

export function useCheckAgeVerification({
  dispensaryId,
  userId,
}: UseCheckAgeVerificationProps): UseCheckAgeVerificationReturn {
  const { isEmbedded, isStoreFront } = useUI();
  const isAgeVerificationFlagEnabled = useDispensaryFlag(
    `hard-age-gate.age-verification-feature-by-dispensary`,
    dispensaryId
  );
  const isWrongVariant = !isEmbedded && !isStoreFront;

  const skip = isWrongVariant || !isAgeVerificationFlagEnabled || !userId || !dispensaryId;
  const variables = {
    dispensaryId: dispensaryId ?? '',
  };

  const { data, loading, error } = useCheckAgeVerificationQuery({
    fetchPolicy: `no-cache`,
    skip,
    variables,
  });

  if (error) {
    throw new GraphqlError(error);
  }

  const isLoading = loading || skip;

  return { isAgeVerified: data?.checkAgeVerification.isAgeVerified, loading: isLoading };
}
